/**
 * Cart Drawer Recommendations
 * - AJAX Add to Cart
 * - Carousel: drag, wheel, scrollbar, auto-scroll
 * - Polls for new carousel elements (works after morph / auto-open)
 */
(function () {
  /* ===================== AJAX ADD TO CART ===================== */
  function handleRecAddToCart(e) {
    var form = e.target.closest('.cart-recs__add-form');
    if (!form) return;
    e.preventDefault();

    var btn = form.querySelector('.cart-recs__add-btn');
    if (!btn || btn.disabled) return;
    btn.disabled = true;
    var origText = btn.textContent;
    btn.textContent = '...';

    var variantId = form.querySelector('input[name="id"]').value;
    var quantity = form.querySelector('input[name="quantity"]').value || '1';

    var sectionIds = [];
    document.querySelectorAll('cart-items-component').forEach(function (el) {
      if (el.dataset.sectionId) sectionIds.push(el.dataset.sectionId);
    });

    fetch(window.Theme?.routes?.cart_add_url || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: parseInt(variantId, 10), quantity: parseInt(quantity, 10) }],
        sections: sectionIds.join(','),
        sections_url: window.location.pathname,
      }),
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: {},
              sourceId: 'cart-recs',
              data: { source: 'cart-drawer-recommendations', sections: data.sections || {}, itemCount: data.item_count || 0 },
            },
          })
        );
      })
      .catch(function (err) { console.error('Cart recs ATC error:', err); })
      .finally(function () { btn.disabled = false; btn.textContent = origText; });
  }

  document.addEventListener('submit', function (e) {
    if (e.target.matches && e.target.matches('.cart-recs__add-form')) handleRecAddToCart(e);
  });
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.cart-recs__add-btn');
    if (!btn) return;
    var form = btn.closest('.cart-recs__add-form');
    if (!form) return;
    e.preventDefault();
    handleRecAddToCart({ target: btn, preventDefault: function () {} });
  });

  /* ===================== CAROUSEL ===================== */
  var DRAG_THRESHOLD = 5;

  function initCarousel(root) {
    var scrollEl = root.querySelector('[data-recs-scroll]');
    if (!scrollEl) return;

    var sbTrack = root.querySelector('[data-recs-scrollbar-track]');
    var sbThumb = root.querySelector('[data-recs-scrollbar-thumb]');

    /* --- Scrollbar --- */
    function updateScrollbar() {
      if (!sbTrack || !sbThumb) return;
      var sw = scrollEl.scrollWidth, cw = scrollEl.clientWidth;
      if (sw <= cw) { sbTrack.style.display = 'none'; return; }
      sbTrack.style.display = '';
      var ratio = cw / sw;
      var thumbW = Math.max(15, ratio * 100);
      sbThumb.style.width = thumbW + '%';
      var scrollRatio = scrollEl.scrollLeft / (sw - cw);
      sbThumb.style.left = (scrollRatio * (100 - thumbW)) + '%';
    }
    scrollEl.addEventListener('scroll', updateScrollbar, { passive: true });
    requestAnimationFrame(updateScrollbar);
    if (window.ResizeObserver) new ResizeObserver(updateScrollbar).observe(scrollEl);

    /* --- Wheel horizontal --- */
    scrollEl.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaY) < 2) return;
      e.preventDefault();
      scrollEl.scrollLeft += e.deltaY;
    }, { passive: false });

    /* --- Mouse drag --- */
    var isDown = false, isDragging = false, didDrag = false;
    var startX = 0, lastX = 0, lastTime = 0, velX = 0;

    scrollEl.addEventListener('mousedown', function (e) {
      if (e.button !== 0) return;
      e.preventDefault();
      isDown = true; isDragging = false; didDrag = false;
      startX = e.clientX; lastX = e.clientX;
      lastTime = performance.now(); velX = 0;
    });

    function onMove(e) {
      if (!isDown) return;
      var dx = e.clientX - lastX;
      var total = Math.abs(e.clientX - startX);

      if (!isDragging && total > DRAG_THRESHOLD) {
        isDragging = true; didDrag = true;
        scrollEl.style.cursor = 'grabbing';
        document.body.style.cursor = 'grabbing';
        document.body.style.userSelect = 'none';
      }

      if (isDragging) {
        var now = performance.now();
        var dt = now - lastTime;
        scrollEl.scrollLeft -= dx;
        if (dt > 0 && dt < 100) velX = (-dx / dt) * 16;
        lastTime = now;
      }
      lastX = e.clientX;
    }

    function onUp(e) {
      if (!isDown) return;
      var wasDragging = isDragging;
      isDown = false; isDragging = false;
      scrollEl.style.cursor = '';
      document.body.style.cursor = '';
      document.body.style.userSelect = '';

      if (wasDragging) {
        e.stopPropagation();
        if (Math.abs(velX) > 0.5) {
          var v = velX;
          (function coast() {
            if (Math.abs(v) < 0.3) return;
            scrollEl.scrollLeft += v;
            v *= 0.94;
            requestAnimationFrame(coast);
          })();
        }
      }
    }

    document.addEventListener('mousemove', onMove);
    document.addEventListener('mouseup', onUp, true);

    root.addEventListener('click', function (e) {
      if (didDrag) { e.preventDefault(); e.stopPropagation(); didDrag = false; }
    }, true);

    scrollEl.addEventListener('dragstart', function (e) { e.preventDefault(); });

    /* --- Keep drawer open on rec link --- */
    if (root.hasAttribute('data-keep-drawer')) {
      root.addEventListener('click', function (e) {
        if (didDrag) return;
        var link = e.target.closest('[data-recs-link]');
        if (!link) return;
        var href = link.getAttribute('href');
        if (href) {
          e.preventDefault();
          window.location.href = href + (href.indexOf('?') > -1 ? '&' : '?') + 'cart_drawer=open';
        }
      });
    }

    /* --- Auto-scroll --- */
    var speed = parseFloat(root.dataset.recsSpeed) || 0;
    if (speed > 0) {
      var lastT = 0;
      (function autoTick(t) {
        requestAnimationFrame(autoTick);
        if (!lastT) { lastT = t; return; }
        var dt = (t - lastT) / 1000; lastT = t;
        if (!isDown && !isDragging) {
          scrollEl.scrollLeft += speed * dt;
          if (scrollEl.scrollLeft >= scrollEl.scrollWidth - scrollEl.clientWidth - 1) scrollEl.scrollLeft = 0;
        }
      })(0);
    }
  }

  /* ===================== POLLING INIT ===================== */
  function pollInit() {
    document.querySelectorAll('[data-cart-recs-root]').forEach(function (el) {
      if (el.hasAttribute('data-recs-ready')) return;
      el.setAttribute('data-recs-ready', '');
      initCarousel(el);
    });
  }
  setInterval(pollInit, 200);
  pollInit();

  /* ===================== AUTO-OPEN DRAWER FROM URL ===================== */
  if (window.location.search.indexOf('cart_drawer=open') > -1) {
    customElements.whenDefined('cart-drawer-component').then(function () {
      var comp = document.querySelector('cart-drawer-component');
      if (comp) setTimeout(function () { if (comp.open) comp.open(); }, 300);
    });
    var cleanUrl = window.location.href.replace(/[?&]cart_drawer=open/, '').replace(/\?$/, '');
    window.history.replaceState(null, '', cleanUrl);
  }
})();